// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiProductCoverage {
    static getAttributeTypeMap() {
        return PharmacyBiProductCoverage.attributeTypeMap;
    }
}
PharmacyBiProductCoverage.discriminator = undefined;
PharmacyBiProductCoverage.additionalProperties = false;
PharmacyBiProductCoverage.attributeTypeMap = [
    {
        "name": "code",
        "baseName": "code",
        "type": "string"
    },
    {
        "name": "covered",
        "baseName": "covered",
        "type": "string"
    },
    {
        "name": "mailOrderCoInsurance",
        "baseName": "mailOrderCoInsurance",
        "type": "string"
    },
    {
        "name": "mailOrderPharmacyCoPay",
        "baseName": "mailOrderPharmacyCoPay",
        "type": "string"
    },
    {
        "name": "mailOrderCovered",
        "baseName": "mailOrderCovered",
        "type": "string"
    },
    {
        "name": "retailPharmacyCoInsurance",
        "baseName": "retailPharmacyCoInsurance",
        "type": "string"
    },
    {
        "name": "retailPharmacyCoPay",
        "baseName": "retailPharmacyCoPay",
        "type": "string"
    },
    {
        "name": "retailPharmacyCovered",
        "baseName": "retailPharmacyCovered",
        "type": "string"
    },
    {
        "name": "specialtyPharmacyCoInsurance",
        "baseName": "specialtyPharmacyCoInsurance",
        "type": "string"
    },
    {
        "name": "specialtyPharmacyCopay",
        "baseName": "specialtyPharmacyCopay",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiProductCoverage.js.map